import {
    type ReactNode,
    type Dispatch,
    createContext,
    useContext,
    useReducer
} from "react";
import type {
    GLOBAL_STATE_CONSTANT_TYPE
} from "../types";
import {
    GLOBAL_STATE_CONSTANT
} from "../constants";

const GlobalStateDispatchContext = createContext<Dispatch<Partial<GLOBAL_STATE_CONSTANT_TYPE>>>(() => GLOBAL_STATE_CONSTANT);
const GlobalStateContext = createContext(GLOBAL_STATE_CONSTANT);

const GlobalStateProvider = ({
    children
}: {
    children: ReactNode
}) => {
    const [state,
        dispatch] = useReducer((prevState, nextState) => {
        const newState = {
            ...prevState,
            ...nextState
        };

        return newState;
    }, GLOBAL_STATE_CONSTANT);

    return <GlobalStateContext.Provider
        value={state}
    >
        <GlobalStateDispatchContext.Provider
            value={dispatch}
        >
            {children}
        </GlobalStateDispatchContext.Provider>
    </GlobalStateContext.Provider>;
};

export const useGlobalState: () => [
    GLOBAL_STATE_CONSTANT_TYPE,
    Dispatch<Partial<GLOBAL_STATE_CONSTANT_TYPE>>
] = () => [
    useContext(GlobalStateContext),
    useContext(GlobalStateDispatchContext)
];
export const useSetGlobalState: () => Dispatch<Partial<GLOBAL_STATE_CONSTANT_TYPE>> = () => useContext(GlobalStateDispatchContext);
export default GlobalStateProvider;
